import * as yup from 'yup';

const MAX_ADDRESS = 150;
const MAX_DESCRIPTION = 150;

export const otherInfoSchema = yup.object({
  emergencyContactName: yup
    .string()
    .trim()
    .required('Emergency contact name is required')
    .min(2, 'Name must be at least 2 characters'),
  relation: yup
    .string()
    .required('Relation is required')
    .test('not-empty', 'Please select relation', (v) => !!v && v !== ''),
  emergencyContactNumber: yup
    .string()
    .required('Emergency contact number is required')
    .test('valid-phone', 'Please enter a valid phone number', (v) => {
      if (!v) return false;
      const digits = v.replace(/\D/g, '');
      return digits.length >= 10 && digits.length <= 15;
    }),
  zipCode: yup.string().trim(),
  state: yup.string().trim(),
  address: yup
    .string()
    .trim()
    .max(MAX_ADDRESS, `Address must be at most ${MAX_ADDRESS} characters`),
  description: yup
    .string()
    .trim()
    .max(MAX_DESCRIPTION, `Description must be at most ${MAX_DESCRIPTION} characters`),
  acceptTerms: yup
    .boolean()
    .oneOf([true], 'You must accept the Terms & Conditions')
    .required(),
});

export type OtherInfoFormValues = yup.InferType<typeof otherInfoSchema>;
